import { AirshipAnimationWithClouds } from '@airship-platform/jam-web/components';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import OnboardingWrapper from './OnboardingWrapper';

const Complete: React.FC = () => {
  useEffect(() => {
    const redirectTimeout = setTimeout(
      () => window.location.replace('/'),
      3000
    );

    return () => {
      clearTimeout(redirectTimeout);
    };
  }, []);

  return (
    <OnboardingWrapper>
      <Typography
        variant="h2"
        sx={{ whiteSpace: 'no-wrap' }}
      >{`Welcome aboard!`}</Typography>
      <Typography variant="body1">
        Thank you for setting up your account.
      </Typography>
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        <AirshipAnimationWithClouds />
      </Grid>
      <Typography variant="body1">You will be redirected soon.</Typography>
    </OnboardingWrapper>
  );
};

export default Complete;
